import axios from "axios";
import { CategorieMessage } from "../../Models/Message/MessageModels";
import { URLAPI } from "../../Setting";
import { errorService } from "../Error/ErrorService";
import dayjs from "dayjs";
import { MessageService } from "./MessageService";
import { DataCategorieIndexation } from "../../Models/Admin/AdminModels";

export function CategorieMessageService(){
    return{
        async getCategoriesMessages(token:string){
            let categories:CategorieMessage[]=[]
            try {
                const response = await axios.get(`${URLAPI+'categoriesMessage'}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const data = response.data['hydra:member'];

                for(const categorie of data){
                    categories.push({
                        id:categorie['id'],
                        nom:categorie['nom'],
                        statut:categorie['statut'],
                        messages:categorie['messages'],
                        typesMagasin:categorie['typesMagasin'],
                        typeMessage:categorie['typeMessage'],
                        code:categorie['code'],
                        debut:new Date(categorie['debut']),
                        fin:new Date(categorie['fin']),
                        magasins:categorie['magasins']
                    });
                }

            } catch (error) {
                errorService().handleError('Erreur pour obtention des catégories de message',error);
                return [];
            }
            return categories;
        },

        async getCategoriesMessagesIndexation(token:string){
            let categories:CategorieMessage[]=[]
            try {
                const responseFixe = await axios.get(`${URLAPI+'categoriesMessage/typeMessage/2'}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const dataFixe = responseFixe.data['hydra:member'];

                const responseHabillage = await axios.get(`${URLAPI+'categoriesMessage/typeMessage/3'}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const dataHabillage = responseHabillage.data['hydra:member'];

                for(const categorie of dataFixe){
                    categories.push({
                        id:categorie['id'],
                        nom:categorie['nom'],
                        statut:categorie['statut'],
                        messages:categorie['messages'],
                        typesMagasin:categorie['typesMagasin'],
                        typeMessage:categorie['typeMessage'],
                        code:categorie['code'],
                        debut:new Date(categorie['debut']),
                        fin:new Date(categorie['fin']),
                        magasins:categorie['magasins']
                    });
                }

                for(const categorie of dataHabillage){
                    categories.push({
                        id:categorie['id'],
                        nom:categorie['nom'],
                        statut:categorie['statut'],
                        messages:categorie['messages'],
                        typesMagasin:categorie['typesMagasin'],
                        typeMessage:categorie['typeMessage'],
                        code:categorie['code'],
                        debut:new Date(categorie['debut']),
                        fin:new Date(categorie['fin']),
                        magasins:categorie['magasins']
                    });
                }

            } catch (error) {
                errorService().handleError('Erreur pour obtention des catégories de message',error);
                return [];
            }
            return categories;
        },

        async getCategoriesMessagesIndexationValide(token:string){
            let categories:CategorieMessage[]=[]
            try {
                const responseFixe = await axios.get(`${URLAPI+'categoriesMessage/typeMessage/2'}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const dataFixe = responseFixe.data['hydra:member'];

                const responseHabillage = await axios.get(`${URLAPI+'categoriesMessage/typeMessage/3'}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const dataHabillage = responseHabillage.data['hydra:member'];

                for(const categorie of dataFixe){
                    if(categorie['statut']==='Valide')
                        categories.push({
                            id:categorie['id'],
                            nom:categorie['nom'],
                            statut:categorie['statut'],
                            messages:categorie['messages'],
                            typesMagasin:categorie['typesMagasin'],
                            typeMessage:categorie['typeMessage'],
                            code:categorie['code'],
                            debut:new Date(categorie['debut']),
                            fin:new Date(categorie['fin']),
                            magasins:categorie['magasins']
                        });
                }

                for(const categorie of dataHabillage){
                    if(categorie['statut']==='Valide')
                        categories.push({
                            id:categorie['id'],
                            nom:categorie['nom'],
                            statut:categorie['statut'],
                            messages:categorie['messages'],
                            typesMagasin:categorie['typesMagasin'],
                            typeMessage:categorie['typeMessage'],
                            code:categorie['code'],
                            debut:new Date(categorie['debut']),
                            fin:new Date(categorie['fin']),
                            magasins:categorie['magasins']
                        });
                }

            } catch (error) {
                errorService().handleError('Erreur pour obtention des catégories de message',error);
                return [];
            }
            return categories;
        },

        async getCategoriesMessagesCatalogueGALECValide(token:string){
            let categories:CategorieMessage[]=[]
            try {
                const response = await axios.get(`${URLAPI+'categoriesMessage/commande'}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const data = response.data['hydra:member'];
                const aujourdhui = dayjs(new Date()).startOf('day');

                for(const categorie of data){
                    // fin incluse au jour pres : une campagne finissant aujourd'hui reste proposee
                    const campagneNonTerminee = !dayjs(categorie['fin']).startOf('day').isBefore(aujourdhui);
                    if((categorie['typeMessage']['type']==='Galec' || categorie['typeMessage']['type']==='Galec Guadeloupe' || categorie['typeMessage']['type']==='Galec Martinique')
                    && categorie['statut']==='Valide' && campagneNonTerminee)
                        categories.push({
                            id:categorie['id'],
                            nom:categorie['nom'],
                            statut:categorie['statut'],
                            messages:categorie['messages'].map((message: any)=>{return {'@id':message}}),
                            typesMagasin:categorie['typesMagasin'],
                            typeMessage:categorie['typeMessage'],
                            code:categorie['code'],
                            debut:new Date(categorie['debut']),
                            fin:new Date(categorie['fin']),
                            magasins:categorie['magasins']
                        });
                }

            } catch (error) {
                errorService().handleError('Erreur pour obtention des catégories de message',error);
                return [];
            }
            return categories;
        },

        async getCategoriesMessagesCatalogueGALECAttente(token:string){
            let categories:CategorieMessage[]=[]
            try {
                const response = await axios.get(`${URLAPI+'categoriesMessage/commande'}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const data = response.data['hydra:member'];

                for(const categorie of data){
                    if((categorie['typeMessage']['type']==='Galec' || categorie['typeMessage']['type']==='Galec Guadeloupe' || categorie['typeMessage']['type']==='Galec Martinique')
                     && categorie['statut']==='Attente')
                        categories.push({
                            id:categorie['id'],
                            nom:categorie['nom'],
                            statut:categorie['statut'],
                            messages:categorie['messages'].map((message: any)=>{return {'@id':message}}),
                            typesMagasin:categorie['typesMagasin'],
                            typeMessage:categorie['typeMessage'],
                            code:categorie['code'],
                            debut:new Date(categorie['debut']),
                            fin:new Date(categorie['fin']),
                            magasins:categorie['magasins']
                        });
                }

            } catch (error) {
                errorService().handleError('Erreur pour obtention des catégories de message',error);
                return [];
            }
            return categories;
        },

        async getCategoriesMessagesCatalogueGALECAdmin(token:string){
            let categories:CategorieMessage[]=[]
            try {
                const responseGalec = await axios.get(`${URLAPI+'categoriesMessage/typeMessage/6'}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const dataGalec = responseGalec.data['hydra:member'];

                const responseGalecGuadeloupe = await axios.get(`${URLAPI+'categoriesMessage/typeMessage/11'}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const dataGalecGuadeloupe = responseGalecGuadeloupe.data['hydra:member'];

                const responseGalecMartinique = await axios.get(`${URLAPI+'categoriesMessage/typeMessage/12'}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const dataGalecMartinique = responseGalecMartinique.data['hydra:member'];

                for(const categorie of dataGalec){
                    categories.push({
                        id:categorie['id'],
                        nom:categorie['nom'],
                        statut:categorie['statut'],
                        messages:categorie['messages'].map((message: any)=>{return {'@id':message}}),
                        typesMagasin:categorie['typesMagasin'],
                        typeMessage:categorie['typeMessage'],
                        code:categorie['code'],
                        debut:new Date(categorie['debut']),
                        fin:new Date(categorie['fin']),
                        magasins:categorie['magasins']
                    });
                }

                for(const categorie of dataGalecGuadeloupe){
                    categories.push({
                        id:categorie['id'],
                        nom:categorie['nom'],
                        statut:categorie['statut'],
                        messages:categorie['messages'].map((message: any)=>{return {'@id':message}}),
                        typesMagasin:categorie['typesMagasin'],
                        typeMessage:categorie['typeMessage'],
                        code:categorie['code'],
                        debut:categorie['debut'],
                        fin:categorie['fin'],
                        magasins:categorie['magasins']
                    });
                }

                for(const categorie of dataGalecMartinique){
                    categories.push({
                        id:categorie['id'],
                        nom:categorie['nom'],
                        statut:categorie['statut'],
                        messages:categorie['messages'].map((message: any)=>{return {'@id':message}}),
                        typesMagasin:categorie['typesMagasin'],
                        typeMessage:categorie['typeMessage'],
                        code:categorie['code'],
                        debut:categorie['debut'],
                        fin:categorie['fin'],
                        magasins:categorie['magasins']
                    });
                }

            } catch (error) {
                errorService().handleError('Erreur pour obtention des catégories de message',error);
                return [];
            }
            return categories;
        },

        async getCategoriesMessagesSCAMARKAttente(token:string){
            let categories:CategorieMessage[]=[]
            try {
                const response = await axios.get(`${URLAPI+'categoriesMessage/commande'}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const data = response.data['hydra:member'];

                for(const categorie of data){
                    if((categorie['typeMessage']['type']==='Scamark' || categorie['typeMessage']['type']==='Scamark DROM') && categorie['statut']==='Attente')
                        categories.push({
                            id:categorie['id'],
                            nom:categorie['nom'],
                            statut:categorie['statut'],
                            messages:categorie['messages'].map((message: any)=>{return {'@id':message}}),
                            typesMagasin:categorie['typesMagasin'],
                            typeMessage:categorie['typeMessage'],
                            code:categorie['code'],
                            debut:new Date(categorie['debut']),
                            fin:new Date(categorie['fin']),
                            magasins:categorie['magasins']
                        });
                }

            } catch (error) {
                errorService().handleError('Erreur pour obtention des catégories de message',error);
                return [];
            }
            return categories;
        },

        async getCategoriesMessagesSCAMARKValide(token:string){
            let categories:CategorieMessage[]=[]
            try {
                const response = await axios.get(`${URLAPI+'categoriesMessage/commande'}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const data = response.data['hydra:member'];
                const aujourdhui = dayjs(new Date()).startOf('day');

                for(const categorie of data){
                    // fin incluse au jour pres : une campagne finissant aujourd'hui reste proposee
                    const campagneNonTerminee = !dayjs(categorie['fin']).startOf('day').isBefore(aujourdhui);
                    if((categorie['typeMessage']['type']==='Scamark' || categorie['typeMessage']['type']==='Scamark DROM') && categorie['statut']==='Valide' && campagneNonTerminee)
                        categories.push({
                            id:categorie['id'],
                            nom:categorie['nom'],
                            statut:categorie['statut'],
                            messages:categorie['messages'].map((message: any)=>{return {'@id':message}}),
                            typesMagasin:categorie['typesMagasin'],
                            typeMessage:categorie['typeMessage'],
                            code:categorie['code'],
                            debut:new Date(categorie['debut']),
                            fin:new Date(categorie['fin']),
                            magasins:categorie['magasins']
                        });
                }

            } catch (error) {
                errorService().handleError('Erreur pour obtention des catégories de message',error);
                return [];
            }
            return categories;
        },

        async getCategoriesMessagesSCAMARKAdmin(token:string){
            let categories:CategorieMessage[]=[]
            try {
                const responseScamark = await axios.get(`${URLAPI+'categoriesMessage/typeMessage/5'}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const dataScamark = responseScamark.data['hydra:member'];

                const responseScamarkDROM = await axios.get(`${URLAPI+'categoriesMessage/typeMessage/10'}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const dataScamarkDROM = responseScamarkDROM.data['hydra:member'];

                for(const categorie of dataScamark){
                    categories.push({
                        id:categorie['id'],
                        nom:categorie['nom'],
                        statut:categorie['statut'],
                        messages:categorie['messages'].map((message: any)=>{return {'@id':message}}),
                        typesMagasin:categorie['typesMagasin'],
                        typeMessage:categorie['typeMessage'],
                        code:categorie['code'],
                        debut:new Date(categorie['debut']),
                        fin:new Date(categorie['fin']),
                        magasins:categorie['magasins']
                    });
                }

                for(const categorie of dataScamarkDROM){
                    categories.push({
                        id:categorie['id'],
                        nom:categorie['nom'],
                        statut:categorie['statut'],
                        messages:categorie['messages'].map((message: any)=>{return {'@id':message}}),
                        // messages:[],
                        typesMagasin:categorie['typesMagasin'],
                        typeMessage:categorie['typeMessage'],
                        code:categorie['code'],
                        debut:categorie['debut'],
                        fin:categorie['fin'],
                        magasins:categorie['magasins']
                    });
                }

            } catch (error) {
                errorService().handleError('Erreur pour obtention des catégories de message',error);
                return [];
            }
            return categories;
        },

        async getCategoriesMessagesCataloguesMidisAttente(token:string){
            let categories:CategorieMessage[]=[]
            try {
                const response = await axios.get(`${URLAPI+'categoriesMessage/commande'}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const data = response.data['hydra:member'];

                for(const categorie of data){
                    if(categorie['typeMessage']['type']==='Cata Midis' && categorie['statut']==='Attente')
                        categories.push({
                            id:categorie['id'],
                            nom:categorie['nom'],
                            statut:categorie['statut'],
                            messages:categorie['messages'].map((message: any)=>{return {'@id':message}}),
                            typesMagasin:categorie['typesMagasin'],
                            typeMessage:categorie['typeMessage'],
                            code:categorie['code'],
                            debut:new Date(categorie['debut']),
                            fin:new Date(categorie['fin']),
                            magasins:categorie['magasins']
                        });
                }

            } catch (error) {
                errorService().handleError('Erreur pour obtention des catégories de message',error);
                return [];
            }
            return categories;
        },

        async getCategoriesMessagesCataloguesMidisValide(token:string){
            let categories:CategorieMessage[]=[]
            try {
                const response = await axios.get(`${URLAPI+'categoriesMessage/commande'}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const data = response.data['hydra:member'];
                const aujourdhui = dayjs(new Date()).startOf('day');

                for(const categorie of data){
                    // fin incluse au jour pres : une campagne finissant aujourd'hui reste proposee
                    const campagneNonTerminee = !dayjs(categorie['fin']).startOf('day').isBefore(aujourdhui);
                    if(categorie['typeMessage']['type']==='Cata Midis' && categorie['statut']==='Valide' && campagneNonTerminee)
                        categories.push({
                            id:categorie['id'],
                            nom:categorie['nom'],
                            statut:categorie['statut'],
                            messages:categorie['messages'].map((message: any)=>{return {'@id':message}}),
                            typesMagasin:categorie['typesMagasin'],
                            typeMessage:categorie['typeMessage'],
                            code:categorie['code'],
                            debut:new Date(categorie['debut']),
                            fin:new Date(categorie['fin']),
                            magasins:categorie['magasins']
                        });
                }

            } catch (error) {
                errorService().handleError('Erreur pour obtention des catégories de message',error);
                return [];
            }
            return categories;
        },

        async getCategoriesMessagesCatalogueMIDISAdmin(token:string){
            let categories:CategorieMessage[]=[]
            try {
                const response = await axios.get(`${URLAPI+'categoriesMessage/typeMessage/8'}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const data = response.data['hydra:member'];

                for(const categorie of data){
                    categories.push({
                        id:categorie['id'],
                        nom:categorie['nom'],
                        statut:categorie['statut'],
                        messages:categorie['messages'].map((message: any)=>{return {'@id':message}}),
                        typesMagasin:categorie['typesMagasin'],
                        typeMessage:categorie['typeMessage'],
                        code:categorie['code'],
                        debut:new Date(categorie['debut']),
                        fin:new Date(categorie['fin']),
                        magasins:categorie['magasins']
                    });
                }

            } catch (error) {
                errorService().handleError('Erreur pour obtention des catégories de message',error);
                return [];
            }
            return categories;
        },

        async postCategorieMessage(nom:string, code:string, debut:Date, fin:Date, typeMessage:number, typesMagasin:number[], token:string){
            try {
                //formattage des dates
                const dateDebutFormatte = dayjs(debut).format('YYYY-MM-DD');
                const dateFinFormatte = dayjs(fin).format('YYYY-MM-DD');

                const postObjectCategorie = {
                    "nom": nom,
                    "code": code,
                    "statut":"Attente",
                    "debut": dateDebutFormatte,
                    "fin": dateFinFormatte,
                    "messages": [],
                    "typeMessage": typeMessage,
                    "typesMagasin": typesMagasin
                    
                };
    
                const reponsePOSTCategorie = await axios.post(
                    `${URLAPI+'categorieMessage'}`,
                    postObjectCategorie,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'application/json',
                        },
                    }
                );
                return reponsePOSTCategorie.status
            } catch (error) {
                errorService().handleError('Erreur création catégorie message', error);
                return 400;
            }
        },

        async postCategorieMessageIndexation(data:DataCategorieIndexation, token:string){
            try {

                const postObjectCategorie = {
                    "nom": data.nom,
                    "statut":"Attente",
                    "messages": [],
                    "typeMessage": data.idTypeMessage,
                    "typesMagasin": data.typesMagasin.map(type=>type.id),
                    "magasins":data.magasins.map(type=>type.id)
                };
    
                const reponsePOSTCategorie = await axios.post(
                    `${URLAPI+'categorieMessage'}`,
                    postObjectCategorie,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'application/json',
                        },
                    }
                );
                return reponsePOSTCategorie.status
            } catch (error) {
                errorService().handleError('Erreur création catégorie message', error);
                return 400;
            }
        },

        async patchCategorieMessage(idCategorie:number, nom:string, statut:string, code:string, debut:Date, fin:Date, typeMessage:number, typesMagasin:number[], token:string){
            try {
                let status = 400;
                //formattage des dates
                const dateDebutFormatte = dayjs(debut).format('YYYY-MM-DD');
                const dateFinFormatte = dayjs(fin).format('YYYY-MM-DD');

                const patchObjectCategorie = {
                    "nom": nom,
                    "code": code,
                    "statut":statut,
                    "debut": dateDebutFormatte,
                    "fin": dateFinFormatte,
                    "typeMessage": typeMessage,
                    "typesMagasin": typesMagasin
                };
    
                const reponsePATCHCategorie = await axios.patch(
                    `${URLAPI+'categorieMessage/'+idCategorie}`,
                    patchObjectCategorie,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'application/json',
                        },
                    }
                );
                status = reponsePATCHCategorie.status

                if(status===200){
                    const messagesCat = await MessageService().getMessagesCategorie(idCategorie, token);
                    for(let mess of messagesCat){
                        mess.debut = debut;
                        mess.fin = fin;
                        status = await MessageService().patchMessageDate(mess.id, mess.debut, mess.fin, token);
                    }
                }

                return status
                
            } catch (error) {
                errorService().handleError('Erreur création catégorie message', error);
                return 400;
            }
        },

        async patchCategorieMessageIndexation(idCategorie:number, statut:string, data:DataCategorieIndexation, token:string){
            try {
                let status = 400;

                const patchObjectCategorie = {
                    "nom": data.nom,
                    "statut":statut,
                    "typeMessage": data.idTypeMessage,
                    "typesMagasin": data.typesMagasin.map(type=>type.id),
                    "magasins":data.magasins.map(type=>type.id)
                };
    
                const reponsePATCHCategorie = await axios.patch(
                    `${URLAPI+'categorieMessage/'+idCategorie}`,
                    patchObjectCategorie,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'application/json',
                        },
                    }
                );
                status = reponsePATCHCategorie.status

                return status
                
            } catch (error) {
                errorService().handleError('Erreur création catégorie message', error);
                return 400;
            }
        },

        async patchStatutCategorieMessage(idCategorie:number, statut:string, token:string){
            try {
                const reponsePATCHCategorie = await axios.patch(
                    `${URLAPI+'categorieMessage/'+idCategorie}`,
                    {"statut":statut},
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'application/json',
                        },
                    }
                );
                return reponsePATCHCategorie.status
            } catch (error) {
                errorService().handleError('Erreur création catégorie message', error);
                return 400;
            }
        },

        async deleteCategorie(idCategorie:number, token:string){
            const responseCategorie = await axios.delete(
                `${URLAPI}categorieMessage/${idCategorie}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            return responseCategorie.status;
        }
    }
}
